import { useEffect, useState } from "react";
import { fetchData, GET_ALL_MOVIES, SEARCH_MOVIES } from "../../components/Service";
import { getEmbededYoutubeUrl, scrollTop } from "../../components/Helper";
import MovieCard from "./partials/MovieCard";

const MovieAll = () => {
	const [list, setList] = useState([]);
	const [pageUrl, setPageUrl] = useState();
	const [searchPageUrl, setSearchPageUrl] = useState();
	const [notFound, setNotFound] = useState(false);
	const [searchKeyword, setSearchKeyword] = useState();

	const getList = () => {
		fetchData(pageUrl ? pageUrl : GET_ALL_MOVIES, "GET", "", false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data?.result);
			} else {
				setNotFound(true);
				setList([]);
			}
		});
	};

	const handleSearch = (keyword) => {
		let payload = {
			keyword: keyword,
		};
		fetchData(searchPageUrl ? searchPageUrl : SEARCH_MOVIES, "POST", payload, false, false, (res) => {
			if (res.status) {
				setNotFound(false);
				setList(res?.data?.result);
			} else {
				setNotFound(true);
				setList([]);
			}
		});
	};

	const updatePageUrl = (url) => {
		if (searchKeyword) {
			setSearchPageUrl(url);
		} else {
			setPageUrl(url);
		}
	};

	const resetSearch = () => {
		setPageUrl();
		setSearchKeyword("");
		setSearchPageUrl();
	};

	useEffect(() => {
		scrollTop();
		getList();
	}, [pageUrl]);

	useEffect(() => {
		scrollTop();
		if (searchKeyword) {
			if (searchKeyword.length > 2) {
				handleSearch(searchKeyword);
			}
		} else {
			getList();
		}
	}, [searchKeyword, searchPageUrl]);

	return (
		<div className="col-lg-12">
			<div className="card card-forum">
				<div className="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-3">
								<h4 className="text-white d-flex mb-0 py-2">All Movies</h4>
							</div>
							<div className="col-lg-9 ms-auto text-start text-lg-end ">
								<div className="input-group innersearch me-1 me-lg-0 ms-0 ms-lg-1 mt2px mb2px height30">
									<input
										type="text"
										className="form-control py-1"
										placeholder="Search here..."
										name="keyword"
										onChange={(e) => setSearchKeyword(e.target.value)}
										value={searchKeyword}
										autoComplete="off"
									/>
								</div>

								<button className="btn btn-light btn-find font13 py-2 me-1 me-lg-0 ms-0 ms-lg-1 px-2 px-lg-3 rounded-1 height30 mb2px mt2px" onClick={resetSearch}>
									<i className="fi fi-br-refresh "></i>
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="card-body bg-white p-1">
					<div className="row">
						{list?.data && list?.data?.length > 0 && list?.data?.map((item) => <MovieCard key={item.id} item={item} />)}
						{notFound && <div className="text-center h6 text-danger py-3">No Records Found!</div>}
					</div>
					{list?.data && (
						<nav className="pt-3">
							<ul className="pagination justify-content-end">
								<li className={`page-item ${list.prev_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => updatePageUrl(list.prev_page_url)}>
										<span aria-hidden="true">&laquo;</span> Previous
									</button>
								</li>
								<li className={`page-item ${list.next_page_url ? "" : "disabled"}`}>
									<button type="button" className="page-link" onClick={() => updatePageUrl(list.next_page_url)}>
										Next <span aria-hidden="true">&raquo;</span>
									</button>
								</li>
							</ul>
						</nav>
					)}
				</div>
			</div>
		</div>
	);
};

export default MovieAll;
